import React from 'react';
import { updateParamsOnImgChildren } from './image-correction-util';

export default function KeyPoint({ children }) {
	// Correct they image processor query params to optimize loading-time
	const imgParams = {
		w: 128,
		h: 128,
	};

	return (
		<div className="flex flex-col px-10 first:pl-0 last:pr-0 [&_img]:m-auto [&_img]:w-32 [&_img]:h-32 ">
			{updateParamsOnImgChildren(children, imgParams)}
		</div>
	);
}
